import { useEffect, useRef } from "react";

export function useMountEffect(callback) {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      callback();
      isMounted.current = true;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export function useUpdateEffect(callback, dependencies) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      callback();
    }
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
}

export function useUnmountEffect(callback) {
  const isUnmounted = useRef(false);

  useEffect(() => {
    return () => {
      isUnmounted.current = true;
      callback();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return isUnmounted.current;
}